import React from 'react';
import factoryImage from '../assets/factory-outside.jpg';
import teamImage from '../assets/team-photo2.jpg';
import panelImage from '../assets/panelOverlay.jpg';

const ContactSection = () => {
  return (
    <section className="relative bg-gradient-to-b from-white to-gray-50 py-20 md:py-32" id="contact">
    {/* Background Image with Overlay */}
    <div className="absolute inset-0">
      <img
        src={panelImage}
        alt="Panel Background"
        className="w-full h-full object-cover"
      />
        <div className="absolute inset-0 bg-blue-900 opacity-70"></div>{" "}
        </div>
  
    {/* Main Content - Add relative and z-index */}
    <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Left Content */}
          <div className="space-y-12">
                        <div className="space-y-8">
                          <h2 className="text-orange-500 text-3xl md:text-4xl font-bold">
                            CONTACT US TODAY!
                          </h2>
                          
                          <div className="space-y-2 text-white text-2xl font-bold">
                            <a href="tel:+09420105050" className="hover:text-orange-500 transition-colors">
                              09-42 010 5050
                            </a>
                            <br />
                            <a href="tel:+09420105055" className="hover:text-orange-500 transition-colors">
                              09-42 010 5055
                            </a>
                          </div>

                          <div className="space-y-2">
                            <p className="text-white text-2xl font-bold">email:</p>
                            <a 
                              href="mailto:contact@sunenergy.com.mm" 
                              className="text-white text-2xl hover:text-orange-500 transition-colors font-medium"
                            >
                              contact@sunenergy.com.mm
                            </a>
                          </div>
                        </div>

            <div className="bg-orange-500 p-8 rounded-xl space-y-4">
              <h3 className="text-white font-bold text-xl">FACTORY</h3>
              <div className="text-white space-y-2 text-lg font-medium">
                <p>151 Yawgi Kyaung Street</p>
                <p>11th Ward, Hlaing Township</p>
                <p>Yangon <span className="text-sm">(Next to MICT Park)</span></p>
              </div>
              
              <div className="pt-4 space-y-2">
                <h3 className="text-white font-bold text-xl">SINGAPORE Office</h3>
                <p className="text-white text-lg font-medium">SKT Techtrade Pte Ltd</p>
                <p className="text-white text-lg">22 Sin Ming Lane, Midview City</p>
                <p className="text-white text-lg">#06-76, Singapore 573969</p>
              </div>
            </div>
          </div>

          {/* Right Images */}
          <div className="grid grid-cols-1 gap-6">
            <div className="h-[300px] rounded-xl overflow-hidden">
              <img
                src={factoryImage}
                alt="Factory Building"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="h-[300px] rounded-xl overflow-hidden">
              <img
                src={teamImage}
                alt="Our Team"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Website Link */}
        <div className="mt-12 text-center text-white text-3xl font-bold">
          <a 
            href="https://www.sunenergy.com.mm" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-white text-xl hover:text-orange-500 transition-colors"
          >
            www.sunenergy.com.mm
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;